import { render, staticRenderFns } from "./ContentOurBrandsSection.vue?vue&type=template&id=3a09c06a"
import script from "./ContentOurBrandsSection.vue?vue&type=script&lang=ts"
export * from "./ContentOurBrandsSection.vue?vue&type=script&lang=ts"
import style0 from "./ContentOurBrandsSection.vue?vue&type=style&index=0&id=3a09c06a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports